import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

// Syncfusion Grid modules
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { ColumnChooserService, FilterService, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';

// Components
import { EligibilityReportComponent } from './eligibility-report.component';

// Child Modules
import { EligibilityDetailsModule } from '../eligibility-details/eligibility-details.module';
import { EligibilityDifferenceReportModule } from '../eligibility-difference-report/eligibility-difference-report.module';

// Services
import { EligibilityReportService } from '../../service/eligibility-report.service';
import { CommonApiService } from 'src/app/service/commonapiservice';
// import { CommonApiService } from '../../services/commonapiservice';

const routes: Routes = [
  {
    path: '',
    component: EligibilityReportComponent
  }
];

@NgModule({
  declarations: [
    EligibilityReportComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    MaskedTextBoxModule,
    DropDownListAllModule,
    EligibilityDetailsModule,
    EligibilityDifferenceReportModule,
    RouterModule.forChild(routes)
  ],
  providers: [
    ColumnChooserService,
    PageService,
    SortService,
    FilterService,
    ResizeService,
    EligibilityReportService,
    CommonApiService
  ],
  exports: [
    EligibilityReportComponent
  ]
})
export class EligibilityReportModule { }
